import styled from 'styled-components';

const ModalContainer = styled.div`
  padding: 20px 20px 0 70px;
`;

export default ModalContainer;
